import React from "react";
import "./CloudsBackground.css";

export default function CloudsBackground() {
  return (
    <div className="clouds-bg" aria-hidden="true">
      <div className="cloud cloud-1" />
      <div className="cloud cloud-2" />
      <div className="cloud cloud-3" />
      <div className="cloud cloud-4" />
      <div className="cloud cloud-5" />
      <div className="cloud cloud-6" />
    </div>
  );
}
